<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">      
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>运营</el-breadcrumb-item>
          <el-breadcrumb-item>新增商家</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-steps :active="activeStep" simple>
          <el-step title="新增商家" icon="el-icon-edit"></el-step>
          <el-step title="新增门店" icon="el-icon-upload"></el-step>
          <el-step title="新增用户" icon="el-icon-picture"></el-step>
        </el-steps>
        <el-card class="box-card" v-if="activeStep==0">
          <div slot="header" class="clearfix">
            <span>新增商家</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <el-form ref="form" v-model="merchant" label-width="80px">
            <el-form-item label="商家名称">
              <el-col :span="11">
                <el-input v-model="merchant.Name" ></el-input>
              </el-col>
            </el-form-item>      
            <el-form-item label="联系人">
              <el-col :span="11">
                <el-input v-model="merchant.Linkman" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-col :span="11">
                <el-input v-model="merchant.Mobile" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="merchant.Memo" ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SaveBusiness">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" v-if="activeStep==1">
          <div slot="header" class="clearfix">
            <span>新增门店</span>
          </div>
          <el-form ref="form" v-model="chainStore" label-width="80px">
            <el-form-item label="门店名称">
              <el-col :span="11">
                <el-input v-model="chainStore.Name" ></el-input>
              </el-col>
            </el-form-item>      
            <el-form-item label="联系人">
              <el-col :span="11">
                <el-input v-model="chainStore.Linkman" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-col :span="11">
                <el-input v-model="chainStore.Mobile" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="chainStore.Memo" ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SaveChainStore">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" v-if="activeStep==2">
          <div slot="header" class="clearfix">
            <span>新增用户</span>
          </div>
          <el-form v-model="user" label-width="80px">
            <el-form-item label="账号">
              <el-col :span="11">
                <el-tooltip class="item" effect="dark" content="子账号必须以@主账号结尾" placement="right">
                  <el-input v-model="user.account"  ></el-input>
                </el-tooltip>
              </el-col>
            </el-form-item>      
            <el-form-item label="联系人">
              <el-col :span="11">
                <el-input v-model="user.name" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-col :span="11">
                <el-input v-model="user.mobile" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="密码">
              <el-col :span="12">
                <el-input v-model="user.password" show-password ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-col :span="12">
                <el-input v-model="user.password2" show-password></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="user.memo" ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SaveUser">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  export default {
    props:{
    },
    data (){
      return {
        activeStep:0,
        merchant:{
          Name:'',
          Linkman:'',
          Mobile:'',
          Memo:''
        },
        chainStore:{
          Name:'',
          Linkman:'',
          Mobile:'',
          Memo:'',
          MerchantId:''    
        },
        user:{
          account:'',
          name:'',
          mobile:'',
          password:'',
          password2:'',
          chainStoreId:0,
          areaId:0,
          memo:''
        }
      }
    },
    computed:{
    },
    mounted(){
      
    },
    methods:{     
      SaveBusiness:function(){
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/merchant/Save',         
            data: that.merchant
          }).then(function (resp) {
            if(resp.data.errorCode==0){   
              that.activeStep = 1;
              that.chainStore.Name = that.merchant.Name
              that.chainStore.Linkman = that.merchant.Linkman
              that.chainStore.Mobile = that.merchant.Mobile
              that.chainStore.Memo = that.merchant.Memo
              that.chainStore.MerchantId = resp.data.id
              that.user.areaId = resp.data.id
              that.$message.success(resp.data.message);
            }else {
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
          })
      },
      SaveChainStore:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ChainStore/Save',         
          data: that.chainStore
        }).then(function (resp) {
          if(resp.data.errorCode==0){   
            that.activeStep = 2;
            that.user.chainStoreId = resp.data.id
            that.user.mobile = that.chainStore.Mobile
            that.user.name = that.chainStore.Linkman
            that.$message.success(resp.data.message)
          }else {
            that.$message.warning(resp.data.message)
          }
        }).catch(resp => {         
        })
      },
      SaveUser:function(){
        if(this.user.password != this.user.password2){
          this.$message.warning("两次输入的密码不一致!")
          return
        } 
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/User/Save',     
          data:that.user    
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 0 24px  
</style>